//   __                     _     _             _
//  / _|_ __ ___  ___   ___| |__ (_)_ __  _ __ (_)_ __   __ _
// | |_| '__/ _ \/ _ \ / __| '_ \| | '_ \| '_ \| | '_ \ / _` |
// |  _| | |  __/  __/ \__ \ | | | | |_) | |_) | | | | | (_| |
// |_| |_|  \___|\___| |___/_| |_|_| .__/| .__/|_|_| |_|\__, |
//                                 |_|   |_|            |___/
// -- SETUP
var free_shipping_amount = 169; // AUD - free delivery threshold
// Section 1: static ShoeGrab-style free-delivery banner (client request). Both states show
// the SAME message, so it reads as one fixed banner regardless of subtotal. The type
// attribute still tracks `reached` so the app's dedup check (re-append when type != reached)
// stays stable and the banner doesn't flicker.
// NOTE: the amount is $169 — the store's ACTUAL free-shipping threshold (see
// free_shipping_amount above, the SHIPS FREE product badge, and the top announcement bar).
// ShoeGrab shows $150 because that's their threshold; showing $150 here would promise free
// delivery the store doesn't give between $150-$168.
var s1_delivery_msg = '<h3>🚚 Free Delivery Orders over $169</h3>';
var custom_upsell_code = [
	'<div class="custom__upsell-items" type="0">' + s1_delivery_msg + '</div>',
	'<div class="custom__upsell-items" type="1">' + s1_delivery_msg + '</div>'
];

var empty_cart_code = '\
<div class="custom__empty-cart"> \
    <h4>YOUR CART IS EMPTY!</h4> \
    <h4>LET\'S CHANGE THAT</h4> \
    \
    <a href="https://freshoutsneakers.com.au/collections/mens">SHOP MENS</a> \
    <a href="https://freshoutsneakers.com.au/collections/womens">SHOP WOMENS</a> \
</div>';


//   __                     _     _             _
//  / _|_ __ ___  ___   ___| |__ (_)_ __  _ __ (_)_ __   __ _
// | |_| '__/ _ \/ _ \ / __| '_ \| | '_ \| '_ \| | '_ \ / _` |
// |  _| | |  __/  __/ \__ \ | | | | |_) | |_) | | | | | (_| |
// |_| |_|  \___|\___| |___/_| |_|_| .__/| .__/|_|_| |_|\__, |
//                                 |_|   |_|            |___/
// -- SETUP
free_shipping_code = function() {
	// Header cart count badge. Prefer the Slide Cart app's authoritative state
	// (SLIDECART_STATE), falling back to summing the drawer's line items. Mirror it into
	// the theme's .cart-link__count span inside .cart-link__icon. Polling every 2s keeps
	// it dynamic for in-drawer removals too, which don't fire theme:cartchanged.
	if ($('.slidecarthq').length > 0) {
		var cartCount = null;
		try {
			var st = window.SLIDECART_STATE;
			if (st) {
				if (st.cart && typeof st.cart.item_count === 'number') cartCount = st.cart.item_count;
				else if (typeof st.item_count === 'number') cartCount = st.item_count;
				else if (st.cart && st.cart.items && st.cart.items.length !== undefined) {
					cartCount = 0;
					for (var ci = 0; ci < st.cart.items.length; ci++) cartCount += (st.cart.items[ci].quantity || 0);
				}
			}
		} catch (e) {}

		if (cartCount === null) {
			// Fallback: drawer line items, but only once the drawer has resolved its state.
			var $items = $('.slidecarthq .items .item');
			var drawerEmpty = $('.slidecarthq div.empty').length > 0;
			if ($items.length > 0 || drawerEmpty) {
				cartCount = 0;
				$items.each(function () {
					var q = parseInt($(this).find('.quantity-selector input').first().val(), 10);
					cartCount += (isNaN(q) || q < 1) ? 1 : q;
				});
			}
		}

		if (cartCount !== null) {
			var $icon = $('.cart-link__icon').first();
			if ($icon.length === 0) $icon = $('.cart-link').first();
			var $badge = $('.cart-link__count');
			if (cartCount > 0) {
				if ($badge.length === 0 && $icon.length) {
					$icon.append('<span class="cart-link__count"></span>');
					$badge = $('.cart-link__count');
				}
				$badge.text(cartCount);
			} else {
				$badge.remove();
			}
		}
	}

	// Free-delivery upsell / threshold. Always recompute from the drawer subtotal so it
	// stays in sync when items are removed (emptied to $0 -> shows the full amount away).
	if ($('.slidecarthq header.header').length > 0) {
		var subtotal = $('footer.footer .footer-row strong.slidecart-subtotal').text().replace('A$', '');
		if (!subtotal) subtotal = '0';
		subtotal = parseFloat(subtotal.replace('$', '').replace(/,/g, '')) || 0;
		var reached = subtotal >= free_shipping_amount ? 1 : 0;

		if ($('.custom__upsell-items').length == 0 || reached != Number($('.custom__upsell-items').attr('type'))) {
			$('.custom__upsell-items').remove();
			$('.slidecarthq header.header').append(custom_upsell_code[reached]);
		}
		if (reached == 0) {
			$('.custom__upsell-items span.custom__upsell-amount').text((free_shipping_amount - subtotal).toFixed(2));
			$('.custom__upsell-items div.custom__progress-bar-progress').attr('style', '--width: ' + (subtotal / free_shipping_amount * 100) + '%; --value: "$' + subtotal.toFixed(2) + '"');
		}
	}

	// Custom empty-cart content.
	if ($('.slidecarthq div.empty').length > 0) {
		if ($('.slidecarthq div.empty').html() != empty_cart_code) $('.slidecarthq div.empty').html(empty_cart_code);
	}
};

//                _            _             _         _
//   ___ ___   __| | ___   ___| |_ __ _ _ __| |_ ___  | |__   ___ _ __ ___
//  / __/ _ \ / _` |/ _ \ / __| __/ _` | '__| __/ __| | '_ \ / _ \ '__/ _ \
// | (_| (_) | (_| |  __/ \__ \ || (_| | |  | |_\__ \ | | | |  __/ | |  __/
//  \___\___/ \__,_|\___| |___/\__\__,_|_|   \__|___/ |_| |_|\___|_|  \___|
// -- here!
$(document).ready(function() {
	// FREE SHIPPING CODE
	setTimeout(function() {
		free_shipping_code();
		$('a.cart-link').on('click', free_shipping_code);
		setInterval(free_shipping_code, 2000);
	}, 1000);
}); // Section 2 fix: missing semicolon caused IIFE below to be parsed as a function call on the jQuery object, throwing TypeError and aborting the rest of the script.

// ============================================================
// Section 2 - Inventory-aware UI for slide-out cart drawer
// ============================================================
// Greys out the + button and shows an "Only X in stock" notice
// for cart items already at max inventory. Uses fetch() (no
// jQuery AJAX dependency) so it works with the slim jQuery
// build the theme loads. Polls every 2 seconds matching the
// existing free_shipping_code pattern above.
// ============================================================
(function () {
  var s2_inventoryCache = {};  // handle -> { variantId: variantObj }

  function s2_getProductInventory(handle) {
    if (s2_inventoryCache[handle]) {
      return Promise.resolve(s2_inventoryCache[handle]);
    }
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (product) {
        var map = {};
        product.variants.forEach(function (v) { map[v.id] = v; });
        s2_inventoryCache[handle] = map;
        return map;
      })
      .catch(function () { return null; });
  }

  function s2_findPlusButton($itemDom) {
    // SlideCartHQ uses aria-label="increase quantity" on the + button.
    // Case-sensitive match (jQuery Sizzle does NOT support the `i` CSS4 flag).
    var $plus = $itemDom.find('.quantity-selector button[aria-label*="increase"]');
    if ($plus.length === 0) {
      // Fallback: the + button is the last <button> inside .quantity-selector
      $plus = $itemDom.find('.quantity-selector button').last();
    }
    return $plus;
  }

  function s2_findQuantityArea() {
    // No longer used - we now append directly to .item (outer container).
    // Kept as a stub for backwards compat if other code references it.
    return $();
  }

  // Debug helper - logs what we found so we can diagnose selector mismatches.
  // Set s2_debugCart = true in browser console to enable.
  window.s2_debugCart = window.s2_debugCart || false;
  function s2_debug(msg, data) {
    if (window.s2_debugCart) {
      console.log('[S2 cart]', msg, data || '');
    }
  }

  // Cache of variant_id -> max-quantity, learned from 422 responses on /cart/change.js.
  // Since Shopify hides quantity_rule.max in /products/{handle}.js on this store,
  // we can't know the cap predictively. Instead we learn it the first time a customer
  // clicks + on an at-max item (the request fails 422), then prevent future clicks.
  var s2_knownMax = {};
  window.s2_knownMax = s2_knownMax;  // expose immediately for diagnostics

  function s2_applyAtMaxToItem(variantId, maxQty) {
    var $itemDom = $('.slidecarthq .item[data-variant-id="' + variantId + '"]');
    if ($itemDom.length === 0) return;
    var $plus = s2_findPlusButton($itemDom);
    $plus.addClass('s2-plus-disabled');
    // Tag the notice with data-for-variant so we can find it across polls.
    // Placed as a CHILD of .item with position:absolute (see CSS) - removed from
    // flex flow so it doesn't get squeezed by the nested flex columns
    // (.item-container, .main, .main-bottom) and doesn't shift the layout when
    // qty buttons are clicked. .item gets position:relative as the anchor.
    var $existing = $('.s2-stock-notice[data-for-variant="' + variantId + '"]');
    if ($existing.length === 0 && typeof maxQty === 'number' && maxQty > 0) {
      var msg = 'Max ' + maxQty;
      $itemDom.append('<div class="s2-stock-notice" data-for-variant="' + variantId + '">' + msg + '</div>');
    }
  }

  function s2_handle422(xhr) {
    s2_debug('handle422 ENTRY', { url: xhr._s2Url, body: xhr._s2Body, response: xhr.responseText && xhr.responseText.substring(0, 300) });
    var data;
    try { data = JSON.parse(xhr.responseText); }
    catch (e) { s2_debug('handle422 EXIT: JSON parse failed', xhr.responseText && xhr.responseText.substring(0, 200)); return; }
    s2_debug('handle422 parsed data', data);

    // Shopify error description is usually like:
    //   "All 1 of \"X\" are in your cart."
    //   "There are only 5 of \"X\" available."
    //   "You can only add 1 of this item to your cart."
    var description = data.description || data.message || '';
    var match = description.match(/(?:only|all|just)\s+(\d+)/i);
    if (!match) { s2_debug('handle422 EXIT: no max number in description', description); return; }
    var maxQty = parseInt(match[1], 10);
    s2_debug('handle422 extracted maxQty', maxQty);

    // Extract variant_id OR line number from request body.
    // SlideCartHQ sends `{"line": N, "quantity": Q}` (line is 1-indexed).
    // Other apps/themes may send `{"id": variantId}` directly.
    var variantId = null;
    var lineNumber = null;
    var body = xhr._s2Body;
    if (body) {
      try {
        if (typeof body === 'string') {
          try {
            var json = JSON.parse(body);
            variantId = json.id;
            lineNumber = json.line;
          } catch (e) {
            var params = new URLSearchParams(body);
            variantId = params.get('id');
            lineNumber = params.get('line');
          }
        } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
          variantId = body.get('id');
          lineNumber = body.get('line');
        }
      } catch (e) {}
    }
    s2_debug('handle422 parsed body', { variantId: variantId, lineNumber: lineNumber });

    // Path A: have variant_id directly -> apply immediately
    if (variantId) {
      variantId = String(variantId);
      s2_knownMax[variantId] = maxQty;
      window.s2_knownMax = s2_knownMax;
      s2_debug('handle422 SUCCESS via variantId', { variantId: variantId, max: maxQty });
      s2_applyAtMaxToItem(variantId, maxQty);
      return;
    }

    // Path B: only have line number -> fetch cart, look up cart.items[line-1].variant_id
    if (lineNumber) {
      var lineIdx = parseInt(lineNumber, 10) - 1;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items[lineIdx]) {
            s2_debug('handle422 EXIT: cart line ' + lineNumber + ' not found');
            return;
          }
          var item = cart.items[lineIdx];
          var vid = String(item.variant_id);
          s2_knownMax[vid] = maxQty;
          window.s2_knownMax = s2_knownMax;
          s2_debug('handle422 SUCCESS via line lookup', { line: lineNumber, variantId: vid, max: maxQty });
          s2_applyAtMaxToItem(vid, maxQty);
        });
      return;
    }

    s2_debug('handle422 EXIT: no variant_id or line in body', body);
  }

  // Install XHR interceptor once, on script load. SlideCartHQ uses axios which uses XHR,
  // so this catches their cart-change requests without us needing to know their API.
  (function s2_installXhrInterceptor() {
    if (!window.XMLHttpRequest || window._s2XhrPatched) return;
    window._s2XhrPatched = true;
    var XHR = XMLHttpRequest.prototype;
    var originalOpen = XHR.open;
    var originalSend = XHR.send;
    XHR.open = function (method, url) {
      this._s2Url = url;
      return originalOpen.apply(this, arguments);
    };
    XHR.send = function (body) {
      var self = this;
      self._s2Body = body;
      self.addEventListener('load', function () {
        // Log every cart-related XHR for diagnostics
        if (self._s2Url && self._s2Url.indexOf('cart') !== -1) {
          s2_debug('cart XHR completed', { url: self._s2Url, status: self.status, body: body });
        }
        if (self._s2Url && /\/cart\/(change|update)\.js/.test(self._s2Url) && self.status === 422) {
          s2_handle422(self);
        }
      });
      return originalSend.apply(self, arguments);
    };
  })();

  function s2_applyInventoryLimits() {
    if ($('.slidecarthq').length === 0) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        // Skip silently on rate-limit (429) or any non-OK status
        if (!r.ok) { s2_debug('cart fetch non-OK', r.status); return null; }
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        s2_debug('cart items', cart.items.length);

        // SlideCartHQ uses div.item with data-variant-id - that's the reliable selector
        var $items = $('.slidecarthq .item');
        s2_debug('found item DOM elements', $items.length);

        cart.items.forEach(function (item, idx) {
          s2_getProductInventory(item.handle).then(function (variants) {
            if (!variants) { s2_debug('no variants for handle', item.handle); return; }
            var v = variants[item.variant_id];
            if (!v) { s2_debug('no variant data for id', item.variant_id); return; }

            // Detection priority on this store (where Shopify hides inventory_quantity):
            //   1. s2_knownMax cache - learned from past 422 responses on /cart/change.js
            //   2. quantity_rule.max - if Shopify happens to expose it
            //   3. available=false + qty>0 - variant sold out but still in cart
            var maxStock = null;
            var variantIdStr = String(item.variant_id);
            if (s2_knownMax[variantIdStr] !== undefined) {
              maxStock = s2_knownMax[variantIdStr];
            } else if (v.quantity_rule && typeof v.quantity_rule.max === 'number' && v.quantity_rule.max > 0) {
              maxStock = v.quantity_rule.max;
            }
            var atMax = false;
            if (maxStock !== null) {
              atMax = item.quantity >= maxStock;
            } else if (v.available === false && item.quantity > 0) {
              atMax = true;
              maxStock = item.quantity;
            }
            s2_debug('item ' + idx + ' (' + item.handle + ')', {
              qty: item.quantity, maxStock: maxStock, available: v.available,
              quantity_rule: v.quantity_rule, atMax: atMax
            });

            // Locate by variant_id (most reliable, doesn't rely on order)
            var $itemDom = $('.slidecarthq .item[data-variant-id="' + item.variant_id + '"]');
            if ($itemDom.length === 0) { s2_debug('no DOM for variant ' + item.variant_id); return; }

            var $plus = s2_findPlusButton($itemDom);
            s2_debug('item ' + idx + ' + button found?', $plus.length + ' element(s), tag=' + ($plus.length ? $plus[0].tagName + '.' + $plus.attr('class') : 'none'));

            // Notice is now a CHILD of .item (position:absolute via CSS) - find by variant.
            var $existingNotice = $('.s2-stock-notice[data-for-variant="' + item.variant_id + '"]');

            if (atMax) {
              $plus.addClass('s2-plus-disabled');
              if ($existingNotice.length === 0 && typeof maxStock === 'number' && maxStock > 0) {
                var msg = 'Max ' + maxStock;
                $itemDom.append('<div class="s2-stock-notice" data-for-variant="' + item.variant_id + '">' + msg + '</div>');
              }
            } else {
              $plus.removeClass('s2-plus-disabled');
              $existingNotice.remove();
            }
          });
        });
      })
      .catch(function (e) { s2_debug('fetch failed', e); });
  }

  // Relabel the slide-cart checkout button to "PROCEED TO CHECKOUT".
  // Handles both <button> (textContent) and <input type=submit> (value attr).
  // Idempotent + runs on an interval because SlideCartHQ re-renders the cart
  // (which would otherwise reset the label back to its native "CHECKOUT").
  function s2_relabelCheckout() {
    var TARGET = 'PROCEED TO CHECKOUT';
    var els = document.querySelectorAll(
      '#slidecart-checkout-form button, #slidecarthq #slidecart-checkout-form button, ' +
      '#slidecart-checkout-form input[type="submit"], #slidecarthq #slidecart-checkout-form input[type="submit"]'
    );
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.tagName === 'INPUT') {
        if (el.value !== TARGET) el.value = TARGET;
      } else {
        if (el.textContent.trim() !== TARGET) el.textContent = TARGET;
      }
    }
  }

  // Section 1: inject a "PayPal" express button below the checkout button in the
  // slide cart (ShoeGrab style), mirroring the product page's Buy-with-PayPal button.
  // Click routes to Shopify's REAL /checkout (the cart already has items), where PayPal
  // is a genuine payment method — no third-party PayPal SDK, no bypassed checkout.
  // Idempotent + re-runs on an interval because SlideCartHQ re-renders the drawer.
  function s1_injectPaypal() {
    var form = document.querySelector('#slidecart-checkout-form, #slidecarthq #slidecart-checkout-form');
    if (!form || !form.parentNode) return;
    if (document.querySelector('.s1-cart-paypal')) return;   // already present
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 's1-cart-paypal';
    btn.setAttribute('aria-label', 'Check out with PayPal');
    // Two-tone italic "PayPal" wordmark rendered as text. (PayPal's own "color" wordmark
    // asset is actually solid black, and font-style:italic gets flattened by
    // font-synthesis, so we slant it with skewX for a reliable italic.) Everything is
    // forced inline with !important because SlideCartHQ's button CSS otherwise flattens
    // it to plain upright black.
    // Weight/size are set on the INNER spans too — SlideCartHQ targets button spans and
    // otherwise flattens them to a thin weight — plus a -webkit-text-stroke so the wordmark
    // reads as heavy as the real PayPal logo. skewX gives the reliable italic slant.
    var wm = 'font-family:\'Helvetica Neue\',Helvetica,Arial,sans-serif !important;font-weight:700 !important;font-size:25px !important;line-height:1 !important;';
    btn.innerHTML = '<span style="display:inline-block !important;transform:skewX(-12deg) !important;letter-spacing:-0.5px !important;' + wm + '">' +
      '<span style="color:#003087 !important;-webkit-text-stroke:0.2px #003087 !important;' + wm + '">Pay</span>' +
      '<span style="color:#009cde !important;-webkit-text-stroke:0.2px #009cde !important;' + wm + '">Pal</span></span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = '/checkout';
    });
    form.parentNode.insertBefore(btn, form.nextSibling);   // sits just below the checkout button
  }

  $(document).ready(function () {
    setTimeout(function () {
      s2_applyInventoryLimits();
      // Poll every 5 seconds (was 2s) - other apps on the page also poll /cart.js
      // and aggressive polling triggers Shopify's rate limiter (HTTP 429).
      setInterval(s2_applyInventoryLimits, 5000);
      // Relabel checkout button - check every 1s so it survives re-renders
      s2_relabelCheckout();
      setInterval(s2_relabelCheckout, 1000);
      // Section 1: inject the PayPal express button, re-check every 1s (survives re-renders)
      s1_injectPaypal();
      setInterval(s1_injectPaypal, 1000);
    }, 1500);
  });

  // Expose to window for diagnostic checks - confirms code is loaded.
  window.s2_applyInventoryLimits = s2_applyInventoryLimits;
  window.s2_getProductInventory = s2_getProductInventory;
})();